import { useFetch } from 'use-http'
import { BasePage } from './BasePage/BasePage'
import { Block } from '../components/Block/Block'
import type { BlockInstance } from '../components/Block/Block'
import { useAppContext } from '../Context'
import { API_URL } from '../util'

type PageProps = {
  title: string
  pageId: string
}

function DynamicPage(props: PageProps) {
  const context = useAppContext()

  let options: {
    headers: {
      'Content-Type': string
      Authorization?: string
    }
  } = {
    headers: {
      'Content-Type': 'application/json'
    }
  }

  if (context.user) {
    options.headers.Authorization = `Token ${context.user?.token}`
  }

  const { loading, data } = useFetch(
    `${API_URL}page/${props.pageId}`,
    options,
    [props.pageId]
  )

  if (loading) return null

  const blocks = (data?.content ?? []).map(
    (instance: BlockInstance, index: number) => (
      <Block key={index} block={instance} />
    )
  )

  // optional per-page typography scale (#42). Only wrap when a scale is set, so
  // pages without one render exactly as before (no extra wrapper/regression).
  const fontScale = Number(data?.fontScale)
  const lineHeightScale = Number(data?.lineHeightScale)
  const pageStyle: React.CSSProperties = {}
  if (fontScale > 0) pageStyle.fontSize = `${fontScale}em`
  if (lineHeightScale > 0) pageStyle.lineHeight = lineHeightScale
  const scaled = pageStyle.fontSize !== undefined || pageStyle.lineHeight !== undefined

  return (
    <BasePage>
      {scaled ? <div style={pageStyle}>{blocks}</div> : blocks}
    </BasePage>
  )
}

export { DynamicPage }
